import Player from "@/components/LottiePlayer";

export default function MoreFeatures() {
  return (
    <section className="my-16 flex flex-col items-center justify-center md:py-12 bg-white bg-center font-['Inter']">
      <div className="xl:max-w-7xl lg:max-w-5xl md:max-w-3xl container px-8 ">
        <div className="text-center text-maingray" tabIndex={0}>
          <h3 className="mb-8 text-4xl md:text-5xl tracking-tight leading-tight font-bold md:leading-tight">
            A flexible platform
          </h3>
          <p className="body-text mb-16 xl:mb-24 mx-auto  max-w-4xl">
            CKAN is a “Data Management System” (DMS). As a CMS is for content, a
            DMS is for data. Like a CMS, a DMS is a platform that can be used to
            create a variety of solutions. CKAN&apos;s open source nature and
            extensive usage make it easy to customize and integrate.
          </p>
        </div>
      </div>
      <div className="xl:max-w-7xl lg:max-w-5xl md:max-w-3xl grid grid-cols-1 lg:grid-cols-3 gap-14 px-4">
        <div tabIndex={0} className="p-16 flex flex-col items-center text-center rounded-3xl shadow-lg transition ease-in-out hover:shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] ">
          <Player
            autoplay
            loop
            src="/assets/icons/data-portal.json"
            style={{ height: "80px", width: "80px" }}
          />
          <h3 className="font-['Inter'] text-2xl font-bold text-orange-400  py-2">
            DATA PORTALS
          </h3>
          <p className="body-text">
            A gateway to your data whether publicly or inside the enterprise.
            CKAN powers the world&apos;s leading data portals.
          </p>
        </div>
        <div tabIndex={0} className="p-16 flex flex-col items-center text-center rounded-3xl shadow-lg transition ease-in-out hover:shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] ">
          <Player
            autoplay
            loop
            src="/assets/icons/data-catalog.json"
            style={{ height: "80px", width: "80px" }}
          />
          <h3 className="font-['Inter'] text-2xl font-bold text-orange-400 py-2">
            DATA CATALOG
          </h3>
          <p className="body-text">
            Inventory your data, collect and standardize metadata, track data
            lineage. CKAN is a standard choice for enterprise data catalogs.
          </p>
        </div>
        <div tabIndex={0} className="p-16 flex flex-col items-center text-center rounded-3xl shadow-lg transition ease-in-out hover:shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] ">
          <Player
            autoplay
            loop
            src="/assets/icons/data-lake.json"
            style={{ height: "80px", width: "80px" }}
          />
          <h3 className="font-['Inter'] text-2xl font-bold text-orange-400 py-2">
            DATA LAKE
          </h3>
          <p className="body-text">
            CKAN stores both metadata and data with unlimited scalability in the
            cloud. It&apos;s therefore a perfect foundation for data lakes &
            meshes.
          </p>
        </div>
      </div>
    </section>
  );
}
